export default __webpack_public_path__ + "static/media/818.5e105c88.png";